<script lang="ts">
  import type { Snippet } from 'svelte'

  let {
    eyebrow,
    level = 'h1',
    variant = 'brand',
    children,
  }: {
    eyebrow: string
    level?: 'h1' | 'h2'
    variant?: 'neutral' | 'brand' | 'warning' | 'success'
    children: Snippet
  } = $props()
</script>

<p
  class={['section-heading-eyebrow', {
    '-variant-neutral': variant === 'neutral',
    '-variant-brand': variant === 'brand',
    '-variant-warning': variant === 'warning',
    '-variant-success': variant === 'success',
  }]}
>
  {eyebrow}
</p>
<svelte:element this={level} class="section-heading-title">{@render children()}</svelte:element>

<style>
  .section-heading-eyebrow {
    font-size: var(--font-size-2);
    font-weight: var(--font-weight-3);
    text-transform: uppercase;
    letter-spacing: var(--letter-spacing-4);
    margin: var(--space-9) 0 var(--space-3);
  }

  .section-heading-eyebrow.-variant-neutral {
    color: var(--color-variant-neutral);
  }

  .section-heading-eyebrow.-variant-brand {
    color: var(--color-variant-brand);
  }

  .section-heading-eyebrow.-variant-warning {
    color: var(--color-variant-warning);
  }

  .section-heading-eyebrow.-variant-success {
    color: var(--color-variant-success);
  }

  .section-heading-title {
    margin: 0;
    font-size: var(--font-size-8);
    font-weight: var(--font-weight-4);
    line-height: var(--line-height-1);
    letter-spacing: var(--letter-spacing-1);
  }
</style>
